import PropTypes from "prop-types";
import { useState } from "react";

import { FormattedMessage } from "react-intl";

import classNames from "classnames";

import { Icon } from "flavours/glitch/components/icon";
import { findVideoLink } from "flavours/glitch/utils/video_links";

// Click-to-load embed for video links without a server-side preview card.
// Nothing is requested from the video provider until the user clicks.
const VideoLinkEmbed = ({ html, fullwidth }) => {
  const [loaded, setLoaded] = useState(false);
  const video = findVideoLink(html);

  if (!video) {
    return null;
  }

  return (
    <div className={classNames("video-link-embed", { "full-width": fullwidth })}>
      {loaded ? (
        <iframe
          className='video-link-embed__frame'
          src={video.embedUrl()}
          title={video.name}
          allow='autoplay; encrypted-media; picture-in-picture; fullscreen'
          allowFullScreen
          sandbox={video.sandbox}
          referrerPolicy='strict-origin-when-cross-origin'
        />
      ) : (
        <button type='button' className='video-link-embed__placeholder' onClick={() => setLoaded(true)}>
          <Icon id='play' />
          <span className='video-link-embed__label'><FormattedMessage id='status.video_embed.load' defaultMessage='Load video from {provider}' values={{ provider: video.name }} /></span>
          <span className='video-link-embed__hint'><FormattedMessage id='status.video_embed.hint' defaultMessage='Connects to {provider} once you click' values={{ provider: video.name }} /></span>
        </button>
      )}
    </div>
  );
};

VideoLinkEmbed.propTypes = {
  html: PropTypes.string,
  fullwidth: PropTypes.bool,
};

export default VideoLinkEmbed;

export const hasVideoLink = (html) => !!findVideoLink(html);
